import React from 'react';
import PropTypes from 'prop-types';

import './fitment-tire-code-description.scss';

function FitmentTireCodeDescription({
  className,
  showDivider = false,
  isHighFloatation,
  isOpen
}) {
  const cdn = 'https://cdn.discounttire.com/sys-master/images';
  const image = isHighFloatation
    ? `${cdn}/hcc/hf1/8888181751838/high-flotation-sidewall.jpg`
    : `${cdn}/h94/he7/8888181456926/p-metric-sidewall.jpg`;
  const styles = [];

  styles.push(showDivider ? 'container-divider' : 'container');
  if (isOpen) {
    styles.push('container-open');
  }

  return (
    <div
      className={className}
      data-testid="tire-description"
      styleName={styles.join(' ')}
    >
      <div
        className={className ? `${className}__description` : null}
        styleName="tire-code-description"
      >
        <img alt="helpful tire size sidewall" src={image} />
        <p>
          Your tire sidewall has a series of numbers that show your specific
          tire and wheel size. Match the numbers from your tire to one of the
          size options below.
        </p>
      </div>
    </div>
  );
}

FitmentTireCodeDescription.propTypes = {
  className: PropTypes.string,
  isHighFloatation: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  showDivider: PropTypes.bool
};

export default FitmentTireCodeDescription;
